import { combineReducers } from "@reduxjs/toolkit";
import { getAllCloseCaptionReducer } from "./slices";

const closeCaptionReducer = combineReducers({
  getAllCloseCaption: getAllCloseCaptionReducer,
});

export default closeCaptionReducer;
